<style scoped>
.zoezi-edit-popover-settings {
    width: 450px;
    max-height: 80vh;
    overflow-y: scroll;
    opacity:1;
    transition: all 250ms ease-in-out;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
}

</style>

<template>
    <toolbox-window :label="$translate('Tool')">
        <component-settings class="zoezi-edit-popover-settings" />
    </toolbox-window>
</template>

<script>
import ToolboxWindow from '../components/ToolboxWindow.vue'
import ComponentSettings from '../components/ComponentSettings.vue'
export default {
    name: 'zoezi-edit-popover',

    components: {
        ComponentSettings,
        ToolboxWindow
    }
}
</script>
